import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import LoginPostSlice from "../Slices/Login/LoginPost";
import EventPostSlice from "../Slices/Events/EventPost";
import EventGetAllSlice from "../Slices/Events/EventGetAll";
import MentorRequirementPostSlice from "../Slices/MentorRequirement/MentorRequirementPost";
import MentorRequirementGetAllSlice from "../Slices/MentorRequirement/MentorRequirementGetAll";
import NewsletterPostSlice from "../Slices/Newsletter/NewsletterPost";
import NewsletterGetAllSlice from "../Slices/Newsletter/NewsletterGetAll";
import NewsletterGetByIdSlice from "../Slices/Newsletter/NewsletterGetById";
import NewsLetterEditByIdSlice from "../Slices/Newsletter/NewsLetterEditById";
import EventGetByIdSlice from "../Slices/Events/EventGetById";
import MentorRequirementGetByIdSlice from "../Slices/MentorRequirement/MentorRequirementGetById";
import AlumniRegistrationGetAllSlice from "../Slices/Reports/RegistrationConformation/AlumniRegistrationGetAll";
import AlumniRegistratioConfirmSlice from "../Slices/Reports/RegistrationConformation/AlumniRegistratioConfirm";
import AlumniRegistrationRejectSlice from "../Slices/Reports/RegistrationConformation/AlumniRegistrationReject";
import RegistrationProfileGetByIdSlice from "../Slices/Reports/RegistrationProfile/RegistrationProfileGetById";
import AlumniSkillsGetByIdSlice from "../Slices/Reports/RegistrationProfile/AlumniSkillsGetById";
import AlumniAwardGetByIdSlice from "../Slices/Reports/RegistrationProfile/AlumniAwardGetById";
import AlumniProjectGetByIdSlice from "../Slices/Reports/RegistrationProfile/AlumniProjectGetById";
import AlumniEducationGetByIdSlice from "../Slices/Reports/RegistrationProfile/AlumniEducationGetById";
import AlumniExperienceGetByIdSlice from "../Slices/Reports/RegistrationProfile/AlumniExperienceGetById";
import RegisterPostSlice from "../Slices/Website/RegisterPost";
import AlumniProfileGetByIdSlice from "../Slices/Website/AlumnipProfileGetById";
import websitehomepageGetByTokenSlice from "../Slices/Website/websitehomepageGetByToken";
import addpostjobSlice from "../Slices/Website/addpostjob";
import JobPostGetAllSlice from "../Slices/Website/JobPostGetAll";
import addpostinternshipSlice from "../Slices/Website/addpostinternship";
import addpostresumeSlice from "../Slices/Reports/RegistrationProfile/addpostresume";
import MyPostForusersSlice from "../Slices/Website/MyPostForusers";
import MyPostForUsersGetAllSlice from "../Slices/Website/MyPostForUsersGetAll";
import ConnectionsGetAllSlice from "../Slices/Website/ConnectionsGetAll";
import ConnectionRequestPostSlice from "../Slices/Website/ConnectionRequestPost";
import aluminipostlikeSlice from "../Slices/Website/aluminipostlike";
import aluminipostlikeGetSlice from "../Slices/Website/aluminipostlikeGet";
import createFeedSlice from "../Slices/Website/createFeed";
import uploadFilesPostSlice from "../Slices/UploadFiles/uploadFilesPost";
import getUserAndConnectionsFeedsWithLikeWithCommentSlice from "../Slices/Website/getUserAndConnectionsFeedsWithLikeWithComment";
// import likeFeedSlice from "../Slices/Posts/likeFeed";
import unlikeFeedSlice from "../Slices/Post/unlikeFeed";
import getCommentsWithRepliesSlice from "../Slices/Post/getCommentsWithReplies";
import commentOnFeedSlice from "../Slices/Post/commentOnFeed";
import replyToCommentSlice from "../Slices/Post/replyToComment";
import getUserByIdSlice from "../Slices/Website/getUserById";
import connectionRequestsFromUseSlice from "../Slices/Connections/connectionRequestsFromUser";
import yourConnectionRequestsSlice from "../Slices/Connections/yourConnectionRequests";
import likeFeedSlice from "../Slices/Post/likeFeed";
import updateConnectionRequestStatusSlice from "../Slices/Connections/updateConnectionRequestStatus";
import getAllUsersSlice from "../Slices/Connections/getAllUsers";
import sendConnectionRequestSlice from "../Slices/Connections/sendConnectionRequest";
import EmailVerifyOtpSlice from "../Slices/VerifyEmail/EmailVerifyOtp";
import EmailSendOtpSlice from "../Slices/VerifyEmail/EmailSendOtp";
import checkCustomerExistForEmailRegisterSlice from "../Slices/VerifyEmail/checkCustomerExistForEmailRegister";
import checkCustomerExistPhoneForRegisterSlice from "../Slices/VerifyEmail/checkCustomerExistPhoneForRegister";
import suggestConnectionsSlice from "../Slices/Connections/suggestConnections";
import GetAllChatRoomsWithReceiverInfoSlice from "../Slices/chat/GetAllChatRoomsWithReceiverInfo"
import GetchatRoomMessageSlice from "../Slices/chat/GetchatRoomMessage"
import sendMessageSlice from "../Slices/chat/sendMessage"
import deleteJobByIdSlice from "../Slices/Website/deleteJobById";
import getJobByIdSlice from "../Slices/Website/getJobById";
import getInternshipByIdSlice from "../Slices/Website/getInternshipById";
import getInternshipsByUserIdSlice from "../Slices/Website/getInternshipsByUserId";
import deleteInternshipByIdSlice from "../Slices/Website/deleteInternshipById";
import getUserConnectionsSlice from "../Slices/Connections/getUserConnections";
import getUserStatsCountSlice from "../Slices/Post/getUserStatsCount";
import createAwardSlice from "../Slices/EditProfile/createAward";
import uploadPdfAndImageSlice from "../Slices/UploadFiles/uploadPdfAndImage";
import getAwardsByUserIdSlice from "../Slices/EditProfile/getAwardsByUserId";
import getAwardByIdSlice from "../Slices/EditProfile/getAwardById";
import deleteAwardSlice from "../Slices/EditProfile/deleteAward";
import updateAwardSlice from "../Slices/EditProfile/updateAward";
import createEducationSlice from "../Slices/EditProfile/createEducation";
import getEducationByIdSlice from "../Slices/EditProfile/getEducationById";
import usergetEducationsByUserIdSlice from "../Slices/EditProfile/usergetEducationsByUserId";
import updateEducationSlice from "../Slices/EditProfile/updateEducation";
import deleteEducationSlice from "../Slices/EditProfile/deleteEducation";
import createExperienceSlice from "../Slices/EditProfile/createExperience";
import getExperienceByIdSlice from "../Slices/EditProfile/getExperienceById";
import getExperiencesByUserIdSlice from "../Slices/EditProfile/getExperiencesByUserId";
import updateExperienceSlice from "../Slices/EditProfile/updateExperience";
import deleteExperienceSlice from "../Slices/EditProfile/deleteExperience";
import createProjectSlice from "../Slices/EditProfile/createProject";
import getProjectsByUserIdSlice from "../Slices/EditProfile/getProjectsByUserId";
import getProjectByIdSlice from "../Slices/EditProfile/getProjectById";
import updateProjectSlice from "../Slices/EditProfile/updateProject";
import deleteProjectSlice from "../Slices/EditProfile/deleteProject";
import getUserSkillsSlice from "../Slices/EditProfile/getUserSkills";
import updateUserStoreInfoSlice from "../Slices/EditProfile/updateUserStoreInfo";
import loginAuthUserSlice from "../Slices/Login/loginAuthUser";
import updateEventSlice from "../Slices/Events/updateEvent";
import deleteEventSlice from "../Slices/Events/deleteEvent";
import updateMentorRequirementSlice from "../Slices/MentorRequirement/updateMentorRequirement";
import deleteMentorRequirementSlice from "../Slices/MentorRequirement/deleteMentorRequirement";
import updateNewsletterSlice from "../Slices/Newsletter/updateNewsletter";
import deleteNewsletterSlice from "../Slices/Newsletter/deleteNewsletter";
import getAuthUserByIdSlice from "../Slices/Login/getAuthUserById";

// 
import getNotificationCategoryCountsSlice from "../Slices/notification/getNotificationCategoryCounts"
import markRoomNotificationsAsReadSlice from "../Slices/notification/markRoomNotificationsAsRead"
import getUserAllUnreadNotificationsSlice from "../Slices/notification/getUserAllUnreadNotifications"
import getUnreadFeedNotificationsSlice from "../Slices/notification/getUnreadFeedNotifications"
import getUnreadConnectionNotificationsSlice from '../Slices/notification/getUnreadConnectionNotifications'
import getUnreadChatNotificationsSlice from "../Slices/notification/getUnreadChatNotifications"
import getUnreadInternshipNotificationsSlice from "../Slices/notification/getUnreadInternshipNotifications"
import getUnreadJobNotificationsSlice from "../Slices/notification/getUnreadJobNotifications"
import getUnreadEventNotificationsSlice from '../Slices/notification/getUnreadEventNotifications'
import getUnreadMentorRequirementNotificationsSlice from "../Slices/notification/getUnreadMentorRequirementNotifications"
import getUnreadNewsletterNotificationsSlice from "../Slices/notification/getUnreadNewsletterNotifications"
import markNotificationAsReadForUserSlice from "../Slices/notification/markNotificationAsReadForUser"
import ProfileviewDetailsByUserIdSlice from "../Slices/EditProfile/ProfileviewDetailsByUserId";
import getUserStatsCountByUserIdSlice from "../Slices/Post/getUserStatsCountByUserId";
import editUserInfoSlice from "../Slices/Login/editUserInfo";
import getUserProfileBannerSlice from "../Slices/EditProfile/getUserProfileBanner";
import getUserAboutSlice from "../Slices/EditProfile/getUserAbout";
import getFeedLikedUsersSlice from "../Slices/Post/getFeedLikedUsers";
import resetPasswordForUserSlice from "../Slices/VerifyEmail/resetPasswordForUser";
import resetPasswordForAuthUserSlice from "../Slices/Login/resetPasswordForAuthUser";

import searchReducer from '../Slices/search/searchSlice';
import globalSearchSlice from '../Slices/search/globalSearch'
import uploadImageSlice from "../Slices/UploadFiles/uploadImage";
import getSiteSettingsSlice from "../Slices/UploadFiles/getSiteSettings";
import saveSiteSettingsSlice from "../Slices/UploadFiles/saveSiteSettings";



const reducer = combineReducers({
  LoginPost: LoginPostSlice,
  EventPost: EventPostSlice,
  EventGetAll: EventGetAllSlice,
  MentorRequirementPost: MentorRequirementPostSlice,
  MentorRequirementGetAll: MentorRequirementGetAllSlice,
  NewsletterPost: NewsletterPostSlice,
  NewsletterGetAll: NewsletterGetAllSlice,
  NewsletterGetById: NewsletterGetByIdSlice,
  NewsLetterEditById: NewsLetterEditByIdSlice,
  EventGetById: EventGetByIdSlice,
  MentorRequirementGetById: MentorRequirementGetByIdSlice,
  AlumniRegistrationGetAll: AlumniRegistrationGetAllSlice,
  AlumniRegistratioConfirm: AlumniRegistratioConfirmSlice,
  AlumniRegistrationReject: AlumniRegistrationRejectSlice,
  RegistrationProfileGetById: RegistrationProfileGetByIdSlice,
  AlumniSkillsGetById: AlumniSkillsGetByIdSlice,
  AlumniAwardGetById: AlumniAwardGetByIdSlice,
  AlumniProjectGetById: AlumniProjectGetByIdSlice,
  AlumniEducationGetById: AlumniEducationGetByIdSlice,
  AlumniExperienceGetById: AlumniExperienceGetByIdSlice,
  RegisterPost: RegisterPostSlice,
  AlumniProfileGetById: AlumniProfileGetByIdSlice,
  websitehomepageGetByToken: websitehomepageGetByTokenSlice,
  addpostjob: addpostjobSlice,
  JobPostGetAll: JobPostGetAllSlice,
  addpostinternship: addpostinternshipSlice,
  addpostresume: addpostresumeSlice,
  MyPostForusers: MyPostForusersSlice,
  MyPostForUsersGetAll: MyPostForUsersGetAllSlice,
  ConnectionsGetAll: ConnectionsGetAllSlice,
  ConnectionRequestPost: ConnectionRequestPostSlice,
  aluminipostlike: aluminipostlikeSlice,
  aluminipostlikeGet: aluminipostlikeGetSlice,
  // -------------------------------------------------------
  createFeed: createFeedSlice,
  uploadFilesPost: uploadFilesPostSlice,
  getUserAndConnectionsFeedsWithLikeWithComment: getUserAndConnectionsFeedsWithLikeWithCommentSlice,
  likeFeed: likeFeedSlice,
  unlikeFeed: unlikeFeedSlice,
  getCommentsWithReplies: getCommentsWithRepliesSlice,
  commentOnFeed: commentOnFeedSlice,
  replyToComment: replyToCommentSlice,
  getUserById: getUserByIdSlice,
  connectionRequestsFromUser: connectionRequestsFromUseSlice,
  yourConnectionRequests: yourConnectionRequestsSlice,
  updateConnectionRequestStatus: updateConnectionRequestStatusSlice,
  getAllUsers: getAllUsersSlice,
  sendConnectionRequest: sendConnectionRequestSlice,
  EmailVerifyOtp: EmailVerifyOtpSlice,
  EmailSendOtp: EmailSendOtpSlice,
  checkCustomerExistForEmailRegister: checkCustomerExistForEmailRegisterSlice,
  checkCustomerExistPhoneForRegister: checkCustomerExistPhoneForRegisterSlice,
  suggestConnections: suggestConnectionsSlice,
  deleteJobById: deleteJobByIdSlice,
  getJobById: getJobByIdSlice,
  getInternshipById: getInternshipByIdSlice,
  getInternshipsByUserId: getInternshipsByUserIdSlice,
  deleteInternshipById: deleteInternshipByIdSlice,
  getUserConnections: getUserConnectionsSlice,
  getUserStatsCount: getUserStatsCountSlice,
  createAward: createAwardSlice,
  uploadPdfAndImage: uploadPdfAndImageSlice,
  getAwardsByUserId: getAwardsByUserIdSlice,
  getAwardById: getAwardByIdSlice,
  deleteAward: deleteAwardSlice,
  updateAward: updateAwardSlice,

  createEducation: createEducationSlice,
  getEducationById: getEducationByIdSlice,
  usergetEducationsByUserId: usergetEducationsByUserIdSlice,
  updateEducation: updateEducationSlice,
  deleteEducation: deleteEducationSlice,
  createExperience: createExperienceSlice,
  getExperienceById: getExperienceByIdSlice,
  getExperiencesByUserId: getExperiencesByUserIdSlice,
  updateExperience: updateExperienceSlice,
  deleteExperience: deleteExperienceSlice,

  createProject: createProjectSlice,
  getProjectsByUserId: getProjectsByUserIdSlice,
  getProjectById: getProjectByIdSlice,
  updateProject: updateProjectSlice,
  deleteProject: deleteProjectSlice,
  getUserSkills: getUserSkillsSlice,

  updateUserStoreInfo: updateUserStoreInfoSlice,
  loginAuthUser: loginAuthUserSlice,
  updateEvent: updateEventSlice,
  deleteEvent: deleteEventSlice,
  updateMentorRequirement: updateMentorRequirementSlice,
  deleteMentorRequirement: deleteMentorRequirementSlice,
  updateNewsletter: updateNewsletterSlice,
  deleteNewsletter: deleteNewsletterSlice,
  getAuthUserById: getAuthUserByIdSlice,

  getUserProfileBanner: getUserProfileBannerSlice,

  //

  getNotificationCategoryCounts: getNotificationCategoryCountsSlice,
  markRoomNotificationsAsRead: markRoomNotificationsAsReadSlice,
  getUserAllUnreadNotifications: getUserAllUnreadNotificationsSlice,
  getUnreadFeedNotifications: getUnreadFeedNotificationsSlice,
  getUnreadConnectionNotifications: getUnreadConnectionNotificationsSlice,
  getUnreadChatNotifications: getUnreadChatNotificationsSlice,
  getUnreadInternshipNotifications: getUnreadInternshipNotificationsSlice,
  getUnreadJobNotifications: getUnreadJobNotificationsSlice,
  getUnreadEventNotifications: getUnreadEventNotificationsSlice,
  getUnreadMentorRequirementNotifications: getUnreadMentorRequirementNotificationsSlice,
  getUnreadNewsletterNotifications: getUnreadNewsletterNotificationsSlice,
  markNotificationAsReadForUser: markNotificationAsReadForUserSlice,
  ProfileviewDetailsByUserId: ProfileviewDetailsByUserIdSlice,
  getUserStatsCountByUserId: getUserStatsCountByUserIdSlice,
  editUserInfo: editUserInfoSlice,
  getUserAbout: getUserAboutSlice,
  getFeedLikedUsers:getFeedLikedUsersSlice,
  resetPasswordForUser:resetPasswordForUserSlice,
  resetPasswordForAuthUser:resetPasswordForAuthUserSlice,




  // 
  GetAllChatRoomsWithReceiverInfo: GetAllChatRoomsWithReceiverInfoSlice,
  GetchatRoomMessage: GetchatRoomMessageSlice,
  sendMessage: sendMessageSlice,

  // ----------------
   search: searchReducer,
  globalSearch:globalSearchSlice,
  uploadImage:uploadImageSlice,
  getSiteSettings:getSiteSettingsSlice,
  saveSiteSettings:saveSiteSettingsSlice,



});

const store = configureStore({
  reducer,
});
export default store;
